
import {Component, Prop, Vue} from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";
import {TranslateResult} from "vue-i18n";

@Component({
  name: 'stock-status',
  components: ServiceContainer().getComponents()
})
export default class extends Vue {
  @Prop({required: true}) private readonly status: 'out-of-stock' | 'in-stock' | 'low-stock' | number;
  @Prop({default: () => 0}) private readonly amountOfInStockSources: number;
  @Prop({default: () => null}) private customLabel: string|null;
  @Prop({default: () => 0}) private readonly lowStockOffset: number;

  private get label(): string | TranslateResult {
    if (this.customLabel) {
      return this.customLabel;
    }

    switch (this.statusIdentifier) {
      case 'out-of-stock':
        return this.$t('Out of stock');
      case 'in-stock':
        return this.$t('{count} items in stock', {count: this.amountOfInStockSources});
      case 'low-stock':
        if (this.amountOfInStockSources > 0) {
          return this.$t('In stock in {count} store(s)', {count: this.amountOfInStockSources});
        }
        return this.$t('Less then {count} items in stock', {count: this.lowStockOffset});
      default:
        return this.$t('{count} items in stock', {count: this.amountOfInStockSources});
    }
  }

  private get statusIdentifier(): string {
    if (typeof this.status === 'string') {
      return this.status;
    }
    switch (this.status) {
      case 1:
        return 'in-stock';
      case 2:
        return 'low-stock';
      case 3:
      default:
        return 'out-of-stock';
    }
  }

  private get stockStatusClass(): string {
    if (this.statusIdentifier === 'low-stock') {
      return '--low-stock';
    } else if (this.statusIdentifier === 'in-stock') {
      return '--in-stock';
    } else {
      return '--out-of-stock';
    }
  }
}
